const SCRIPT_NAME = 'themeSwitch.js';

// Gültige Theme-Werte
const VALID_THEMES = ["light", "dark"];

// Theme anwenden, falls gültig
function applyTheme(theme) {
    utils.consoleLog(SCRIPT_NAME, `Versuche, Theme anzuwenden: ${theme}`);

    if (!VALID_THEMES.includes(theme)) {
        utils.consoleLog(SCRIPT_NAME, `Ungültiges Theme: ${theme}`);
        return;
    }

    utils.consoleLog(SCRIPT_NAME, `Theme ist gültig: ${theme}`);
    document.documentElement.setAttribute("data-bs-theme", theme);

    const ICON = document.querySelector('button[name="switchBsTheme"] i');
    if (ICON) {
        utils.consoleLog(SCRIPT_NAME, `Aktualisiere Icon für Theme: ${theme}`);
        ICON.classList.toggle("fa-moon", theme === "dark");
        ICON.classList.toggle("fa-sun-bright", theme === "light");
    } else {
        utils.consoleLog(SCRIPT_NAME, "Kein Icon gefunden, um das Theme-Icon zu aktualisieren.");
    }
}

// Initialisierung des Theme-Switch-Buttons
export function initThemeSwitch() {
    utils.consoleLog(SCRIPT_NAME, "Initialisiere Theme-Switch.");

    // Theme aus Cookie anwenden, falls vorhanden und gültig
    const SAVED_THEME = cookies.getCookie("bsTheme");
    if (SAVED_THEME) {
        utils.consoleLog(SCRIPT_NAME, `Gefundenes gespeichertes Theme: ${SAVED_THEME}`);
        applyTheme(SAVED_THEME);
    } else {
        utils.consoleLog(SCRIPT_NAME, "Kein gespeichertes Theme gefunden.");
        applyTheme("light");
    }

    // Event-Listener für den Toggle-Button
    const TOGGLE_BUTTON = document.querySelector('button[name="switchBsTheme"]');
    if (!TOGGLE_BUTTON) {
        utils.consoleLog(SCRIPT_NAME, "Toggle-Button nicht gefunden!");
        console.error("Toggle-Button nicht gefunden!");
        return;
    }

    utils.consoleLog(SCRIPT_NAME, "Toggle-Button gefunden, registriere Click-Event.");

    TOGGLE_BUTTON.addEventListener("click", function (event) {
        event.preventDefault();
        utils.consoleLog(SCRIPT_NAME, "Toggle-Button wurde geklickt.");

        const HTML_EL = document.documentElement;
        const CURRENT_THEME = HTML_EL.getAttribute("data-bs-theme");
        utils.consoleLog(SCRIPT_NAME, `Aktuelles Theme: ${CURRENT_THEME}`);

        const NEW_THEME = CURRENT_THEME === "dark" ? "light" : "dark";
        utils.consoleLog(SCRIPT_NAME, `Neues Theme: ${NEW_THEME}`);

        applyTheme(NEW_THEME);
        cookies.setCookie("bsTheme", NEW_THEME, 365);
    });

    utils.consoleLog(SCRIPT_NAME, "Theme-Switch vollständig initialisiert.");
}
